import * as integrationsAPI from '@debbie/cortex/dist/api/integrations.js';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { errorNotification } from '../../utils/errors.js';
const ActivateIntegration = (props) => {
    const history = useHistory();
    const lang = useSelector((s) => s.lang);
    useEffect(() => {
        const options = props.options != null
            ? JSON.parse(JSON.parse(decodeURIComponent(props.options)))
            : undefined;
        integrationsAPI
            .activate(props.id, {
            creditorId: props.creditorId,
            authentication: {
                token: props.token,
            },
            options: options,
        })
            .then(() => {
            history.push(window.location.pathname);
        })
            .catch((err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.integration);
        });
    }, [props.token]);
    return React.createElement(React.Fragment, null);
};
export default ActivateIntegration;
//# sourceMappingURL=ActivateIntegration.js.map